import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioFranquiaListarComponent } from './usuario-franquia-listar/usuario-franquia-listar.component';
import { UsuarioFranquiaEditarComponent } from './usuario-franquia-editar/usuario-franquia-editar.component';
import { UsuarioFranquiaDetalharComponent } from './usuario-franquia-detalhar/usuario-franquia-detalhar.component';
import { UsuarioFranquiaInserirComponent } from './usuario-franquia-inserir/usuario-franquia-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, component: UsuarioFranquiaListarComponent },
        { path: 'inserir', data: { breadcrumb : 'Novo Vínculo' }, component: UsuarioFranquiaInserirComponent},
        { path: 'editar/:id', data: { breadcrumb : 'Editar' }, component: UsuarioFranquiaEditarComponent },  
        { path: 'detalhar/:id', data: { breadcrumb : 'Detalhar' }, component: UsuarioFranquiaDetalharComponent },
    
    ])],
    exports: [RouterModule]
})
export class UsuarioFranquiaAppRoutingModule { }